import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { SmsCount } from '../_models';
import { ArrayResponse, BaseResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SmsCountService {

  constructor(private http: HttpClient) { }

  getAll(filter: any, realtimeFlag: boolean): Observable<ArrayResponse>  { //listing
    return this.http.post(`${environment.apiUrl}/report/sms-count/graph?realtime=${realtimeFlag}`, filter)
    .pipe(
      map((data: ArrayResponse) => {
        if(data.status !== 1 || (data.status == 1 && !data.data)){
          return null;
        }else{
          return new ArrayResponse().deserialize(data, SmsCount);
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  export(filter: any, realtimeFlag: boolean): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/report/sms-count/export?realtime=${realtimeFlag}`, filter);
  }

}
